import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { LLAVES_PERMISOS, SECCIONES_PERMISOS } from "./permisos";

const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });

function PermisosModal({ usuario, toggle }) {
  const URL_USERS = process.env.REACT_APP_URL_USERS;
  const [permisos, setPermisos] = useState(null);
  const [buscar, setBuscar] = useState("");
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (!usuario) return;
    setPermisos(null);
    setBuscar("");
    axios.get(`${URL_USERS}/${usuario._id}`, { headers: headers() }).then((r) => {
      const inicial = {};
      LLAVES_PERMISOS.forEach((k) => { inicial[k] = !!r.data[k]; });
      setPermisos(inicial);
    }).catch(console.log);
  }, [usuario, URL_USERS]);

  const secciones = useMemo(() => {
    const q = buscar.trim().toLowerCase();
    if (!q) return SECCIONES_PERMISOS;
    return SECCIONES_PERMISOS
      .map((s) => ({ ...s, permisos: s.titulo.toLowerCase().includes(q) ? s.permisos : s.permisos.filter(([, t]) => t.toLowerCase().includes(q)) }))
      .filter((s) => s.permisos.length);
  }, [buscar]);

  const activos = permisos ? LLAVES_PERMISOS.filter((k) => permisos[k]).length : 0;
  const cambiar = (llaves, valor) => setPermisos((p) => {
    const n = { ...p };
    llaves.forEach((k) => { n[k] = valor; });
    return n;
  });

  const guardar = async () => {
    setGuardando(true);
    try {
      await axios.patch(`${URL_USERS}/${usuario._id}`, permisos, { headers: headers() });
      toggle();
      Swal.fire("Permisos actualizados", "Se aplican cuando el usuario vuelva a iniciar sesion", "success");
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se guardaron", text: error.response?.data?.message || "Intenta de nuevo" });
    }
    setGuardando(false);
  };

  return (
    <Modal size="xl" isOpen={!!usuario} toggle={toggle} className="permisos-modal">
      <ModalHeader toggle={toggle}>Permisos de {usuario?.nombre} {usuario?.apellido}</ModalHeader>
      <ModalBody>
        {permisos ? (
          <>
            <div className="permisos-barra">
              <span className="permisos-total">{activos} de {LLAVES_PERMISOS.length} permisos activos</span>
              <Input bsSize="sm" placeholder="Buscar permiso" value={buscar} onChange={(e) => setBuscar(e.target.value)} />
              <Button size="sm" color="secondary" onClick={() => cambiar(LLAVES_PERMISOS, true)}>Activar todos</Button>
              <Button size="sm" color="secondary" onClick={() => cambiar(LLAVES_PERMISOS, false)}>Quitar todos</Button>
            </div>
            <div className="permisos-grid">
              {secciones.map((s) => {
                const llaves = s.permisos.map(([k]) => k);
                const on = llaves.filter((k) => permisos[k]).length;
                return (
                  <section key={s.id} className="permisos-card">
                    <header>
                      <span className="permisos-icono" style={{ color: s.color, background: `${s.color}14` }}><i className={s.icono} /></span>
                      <div><strong>{s.titulo}</strong><small>{on} de {llaves.length}</small></div>
                      <button type="button" className="permisos-todos" onClick={() => cambiar(llaves, on !== llaves.length)}>
                        {on === llaves.length ? "Quitar" : "Todos"}
                      </button>
                    </header>
                    {s.permisos.map(([k, texto]) => (
                      <label key={k} className="permisos-fila">
                        <span>{texto}</span>
                        <input type="checkbox" className="permisos-switch" checked={permisos[k]} onChange={(e) => cambiar([k], e.target.checked)} />
                      </label>
                    ))}
                  </section>
                );
              })}
            </div>
          </>
        ) : <p className="text-center">Cargando permisos...</p>}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
        <Button color="primary" disabled={!permisos || guardando} onClick={guardar}>{guardando ? "Guardando..." : "Guardar permisos"}</Button>
      </ModalFooter>
    </Modal>
  );
}

export default PermisosModal;
